import {
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

import { UserRoleEnum } from '@app/types';

export class GetCreateEventTypeParticipantOptionsDto {
  @IsUUID()
  @IsNotEmpty()
  eventTypeId: string;

  @IsUUID()
  @IsNotEmpty()
  roleId: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;

  @IsString()
  @IsOptional()
  search?: string;

  @IsString()
  @IsOptional()
  role?: UserRoleEnum;
}
